import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage";
import Light from "./headers/light";
import "./propos.css";
import AboutUs from "./AboutUs";
import { useTranslation } from 'react-i18next';
import Footerr from "./footers/Footer";
const AboutLadyCosmeticos = () => {
  const { t } = useTranslation();
  return (
    <AnimationRevealPage>
      <Light />
      <div
        style={{
          padding: "80px 0",
          margin: "0px",
          textAlign: "center",
          width: "100vw",
          marginLeft: "calc(-50vw + 50%)",
          height: "300px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <h1
          style={{
            color: "#000000",
            fontWeight: "bold",
            fontSize: "52px",
            margin: 0,
          }}
        >
          {t('about.title')}
        </h1>
      </div>

      <AboutUs />

      <section className="lab-quality-section">
        {/* Section 1: Lab */}
        <div className="lab-section">
          <h2 className="section-title">{t('about.lab_title')}</h2>
          <p className="section-text">{t('about.lab_p1')}</p>
          <p className="section-text">{t('about.lab_p2')}</p>
          <p className="section-text">{t('about.lab_p3')}</p>
          <p className="section-text">{t('about.lab_p4')}</p>
        </div>

        {/* Section 2: Quality */}
        <div className="quality-section">
          <h2 className="section-title">{t('about.quality_title')}</h2>
          <p className="section-text">{t('about.quality_p1')}</p>
        </div>
      </section>
  
{/* <Container fluid className="py-5" style={{ backgroundColor: "#ffffff" }}>
  <Row className="align-items-center flex-column-reverse flex-md-row">
    <Col md={7}>
      <div className="px-4 py-4">
        <div className="d-flex align-items-center gap-4 mb-4">
          <img src={onsa} alt="ONSSA" height="50" width="50" />
          <img src={dmp} alt="DMP" height="50" width="50" />
        </div>

        <h2 style={{ color: "#4e7662", fontWeight: "700", fontSize: "32px" }}>
     {t('Pourquoi_nous_choisir')}
        </h2>
        <p className="text-muted mb-5" style={{ maxWidth: "600px" }}>
     {t('t_Pourquoi_nous_choisir')}
        </p>

        <div className="d-flex flex-column gap-4">
          <div className="d-flex">
            <div
              style={{
                minWidth: "40px",
                height: "40px",
                backgroundColor: "#4e7662",
                color: "#fff",
                borderRadius: "50%",
                textAlign: "center",
                lineHeight: "40px",
                fontWeight: "bold",
                marginRight: "15px",
              }}
            >
              1
            </div>
            <div>
              <h5 style={{ color: "#4e7662", fontWeight: "600" }}>     {t('Produits_Certifiés')}
</h5>
              <p className="text-muted mb-0">
     {t('t_Produits_Certifiés')}
              </p>
            </div>
          </div>
          <div className="d-flex">
            <div
              style={{
                minWidth: "40px",
                height: "40px",
                backgroundColor: "#4e7662",
                color: "#fff",
                borderRadius: "50%",
                textAlign: "center",
                lineHeight: "40px",
                fontWeight: "bold",
                marginRight: "15px",
              }}
            >
              2
            </div>
            <div>
              <h5 style={{ color: "#4e7662", fontWeight: "600" }}>     {t('Notre_Vision')} </h5>
              <p className="text-muted mb-0">
     {t('t_Notre_Vision')}
              </p>
            </div>
          </div>
          <div className="d-flex">
            <div
              style={{
                minWidth: "40px",
                height: "40px",
                backgroundColor: "#4e7662",
                color: "#fff",
                borderRadius: "50%",
                textAlign: "center",
                lineHeight: "40px",
                fontWeight: "bold",
                marginRight: "15px",
              }}
            >
              3
            </div>
            <div>
              <h5 style={{ color: "#4e7662", fontWeight: "600" }}>     {t('Notre_Mission')}
 </h5>
              <p className="text-muted mb-0">
     {t('t_Notre_Mission')}
              </p>
            </div>
          </div>
        </div>
      </div>
    </Col>

    <Col md={5} className="text-center position-relative">
      <div style={{ position: "relative", padding: "2rem" }}>
        <div
          style={{
            position: "absolute",
            top: "10%",
            left: "5%",
            width: "90%",
            height: "90%",
            background: "radial-gradient(circle, #4e7662 10%, transparent 70%)",
            zIndex: 0,
            borderRadius: "50%",
          }}
        ></div>
        <Image
          src={catalogue}
          rounded
          fluid
          style={{ borderRadius: "30px", position: "relative", zIndex: 1 }}
        />
      </div>
    </Col>
  </Row>
</Container> */}

      <Footerr />
    </AnimationRevealPage>
  );
};

export default AboutLadyCosmeticos;
